// Timezone is a conservative hint, not a reliable statement of a visitor's country.
export function consentRequired(zone) {
  if (!zone || typeof zone !== 'string') return true;
  if (zone.startsWith('Europe/') || ['Atlantic/Azores', 'Atlantic/Madeira', 'Atlantic/Canary', 'Atlantic/Faroe', 'Atlantic/Reykjavik', 'Arctic/Longyearbyen', 'Asia/Nicosia', 'Asia/Famagusta'].includes(zone)) return true;
  if (['America/Sao_Paulo', 'America/Araguaina', 'America/Bahia', 'America/Belem', 'America/Boa_Vista', 'America/Campo_Grande', 'America/Cuiaba', 'America/Eirunepe', 'America/Fortaleza', 'America/Maceio', 'America/Manaus', 'America/Noronha', 'America/Porto_Velho', 'America/Recife', 'America/Rio_Branco', 'Brazil/Acre', 'Brazil/DeNoronha', 'Brazil/East', 'Brazil/West'].includes(zone)) return true;
  try {
    return !Intl.supportedValuesOf('timeZone').includes(zone);
  } catch {
    return true;
  }
}
export function defaultConsent() {
  try {
    return consentRequired(Intl.DateTimeFormat().resolvedOptions().timeZone) ? null : 'granted';
  } catch {
    return null;
  }
}
